import { Dispatch } from "redux";
import axios from "axios";
import {QuicktipTrackingActionTypes, QuicktipTrackingAction} from "../../types/Quicktip/quicktipTrackingTypes";

interface ErrorResponse {
    code: number;
    message: string;
}

export const trackingQuicktip = (code: string): any => {
    return async (dispatch: Dispatch<QuicktipTrackingAction>) => {
        try {
            dispatch({ type: QuicktipTrackingActionTypes.FETCH_QUICKTIP_TRACKING_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/tickets/${code}`,
                withCredentials: false
            });
            dispatch({ type: QuicktipTrackingActionTypes.FETCH_QUICKTIP_TRACKING_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuicktipTrackingActionTypes.FETCH_QUICKTIP_TRACKING_DATA_ERROR, payload: errorPayload });
        }
    }
}
